import { render, staticRenderFns } from "./CabAdminUsage.vue?vue&type=template&id=6339e12e&scoped=true"
import script from "./CabAdminUsage.vue?vue&type=script&lang=js"
export * from "./CabAdminUsage.vue?vue&type=script&lang=js"
import style0 from "./CabAdminUsage.vue?vue&type=style&index=0&id=6339e12e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6339e12e",
  null
  
)

export default component.exports